const INITIAL_STATE = {
  userName: "",
  theme: "dark",
  itemsForPage: 20,
};
// let HandlerTheme = () => {
//   console.log("theme change of " + color);
//   dark ? setDark(true) : setDark(false);
//   setColor(!dark ? "light" : "dark");
// };

const reducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case "@user/login":
      return {
        ...state,
        userName: action.payload,
      };
    case "@itemsForPage/change":
      return {
        ...state,
        itemsForPage: action.payload,
      };
    case "@user/logout":
      return {
        ...state,
        userName: "",
      };
    case "@theme/light":
      return {
        ...state,
        theme: "light",
      };
    case "@theme/dark":
      return {
        ...state,
        theme: "dark",
      };
    default:
      return state;
  }
};

export default reducer;

/*
@user/login
@user/logout
*/
